import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
  FeeClassificationsDropDownComponent,
  FieldDropSide,
  FieldInput,
  FieldTextarea,
  LoaderWrapper,
  ManageFeeLayout,
} from "../../../components";
import { Button, Form, InputGroup } from "react-bootstrap";
import {
  FLOW_TYPES,
  MANAGE_FEE_ROUTES,
  ROUTES,
  formFields,
  getPathWithParam,
  manageFeeFormNames,
  getAdvancedPathWithParam,
} from "../../../utils";
import { Field, Formik } from "formik";
import { get, isEmpty, isUndefined } from "lodash";
import { useRequest, useRouterParams } from "../../../abstracts";
import {
  getFeeClassifications,
  getFeeDetailsById,
  saveBasicFeeDetails,
} from "../../../services";
import {
  manageFeeStore,
  setBasicFeeData,
  setFeeIdInfo,
  setFeeIsLoading,
} from "../../../contexts";

const CreateFeeContainer = (props) => {
  const history = useHistory();
  const { state, dispatch } = useContext(manageFeeStore);
  const apiData = get(state, "api.data", {});
  const getBasicFeeDetails = get(apiData, "basicFeeDetails", {});
  console.log(
    "getBasicFeeDetails",
    getBasicFeeDetails,
    get(getBasicFeeDetails, "feeStatus", "")
  );
  const formName = manageFeeFormNames.FEE_BASIC_DETAILS;
  const fields = formFields[formName];
  const [isLoading, setIsLoading] = useState(false);
  const [feeStatus, setFeeStatus] = useState(false);
  const [newFeeClassificationList, setNewFeeClassificationList] = useState([]);
  const initialValues = {};
  const { feeId, flow } = useRouterParams();
  const [newFlow] = useState("");
  let stepNumber;
  useEffect(() => {
    if (feeId && isEmpty(getBasicFeeDetails)) {
      dispatch(setFeeIsLoading(true));
      getFeeDetailsById(feeId).then((res) => {
        console.log("resss", res?.basicFeeDetails?.feeStatus);
        if (res.isSuccessfull) {
          {
            res?.basicFeeDetails?.feeStatus == 2
              ? setFeeStatus(true)
              : setFeeStatus(false);
          }
          console.log(
            "feeStatus8999",
            feeStatus,
            get(getBasicFeeDetails, "feeStatus") == 1
          );
          dispatch(setBasicFeeData(res));
          dispatch(
            setFeeIdInfo({
              id: res.basicFeeDetails.id,
              step: res.basicFeeDetails.step,
            })
          );
        }
      });
    } else {
      {
        get(getBasicFeeDetails, "feeStatus") == 2
          ? setFeeStatus(true)
          : setFeeStatus(false);
      }
    }
  }, []);

  console.log("feeStatus", feeStatus);

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.FEE,
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
  ];

  const editbuttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      link: ROUTES.FEE,
    },
    {
      label: "Next",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_FEE_ROUTES.CALCULATION,
            pathParam: [FLOW_TYPES.EDIT, feeId],
          })
        ),
    },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_FEE_ROUTES.BASIC_DETAILS,
    //         pathParam: [FLOW_TYPES.SAVE, feeId],
    //       })
    //     ),
    // },
    {
      label: "Save & Proceed",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setIsLoading(true);
    saveBasicFeeDetails({
      ...values,
      id: feeId,
      feeStatus: feeStatus == true ? 2 : 3,
      feeClassification: {
        name: values.feeClassificationName,
        id: values.feeClassification,
      },
    }).then((res) => {
      if (res.isSuccessful) {
        setIsLoading(false);
        var payload = {
          isSuccessfull: res.isSuccessful,
          basicFeeDetails: res.fee,
        };
        dispatch(setBasicFeeData(payload));
        dispatch(
          setFeeIdInfo({
            id: res.fee.id,
            step: res.fee.step,
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_FEE_ROUTES.CALCULATION,
            pathParam:
              res.fee.step >= 5 ? [FLOW_TYPES.SAVE, res.fee.id] : [res.fee.id],
          })
        );
      } else {
        setIsLoading(false);
        for (var i = 0; i < res.errorMessages.length; i++) {
          var _ = res.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;

  return (
    <LoaderWrapper isLoading={isLoading}>
      <div className="w-100 reports-container min-width-200">
        <Formik
          initialValues={{
            ...initialValues,
            [fields.name]: get(getBasicFeeDetails, "name", ""),
            [fields.description]: get(getBasicFeeDetails, "description", ""),
            [fields.feeClassification]: get(
              getBasicFeeDetails,
              "feeClassification.id",
              0
            ),
            [fields.feeClassificationName]: get(
              getBasicFeeDetails,
              "feeClassification.name",
              ""
            ),
            [fields.feeStatus]:
              get(getBasicFeeDetails, "feeStatus") == 2 ? true : false,
          }}
          onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setErrors,
            values,
            ...rest
          }) => {
            return (
              <Form
                autoComplete="off"
                className="mb-20 mt-10 header-button-form"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <ManageFeeLayout
                  isCreateFee={true}
                  buttons={
                    get(getBasicFeeDetails, "step") >= 5 ? editbuttons : buttons
                  }
                  pageFlow={flow}
                >
                  <Field
                    size="md"
                    isRequired
                    name={fields.name}
                    label={"Fee Name"}
                    type="text"
                    autoComplete="off"
                    value={values[fields.name]}
                    onChange={handleChange}
                    component={FieldInput}
                    disabled={isEdit && !isSave}
                  />
                  <Field
                    label="Fee Description"
                    name={fields.description}
                    autoComplete="off"
                    value={values[fields.description]}
                    onChange={handleChange}
                    component={FieldTextarea}
                    disabled={isEdit && !isSave}
                    size="md"
                  />
                  {/* <textarea
                  style={{ color: "grey", width: "19rem" }}
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  name={fields.feeDescription}
                  value={values[fields.feeDescription]}
                /> */}
                  <div className="mt-3">
                    <Field
                      isRequired
                      label="Fee Classification"
                      name={fields.feeClassificationName}
                      value={values[fields.feeClassificationName]}
                      options={newFeeClassificationList}
                      popupContent={
                        <FeeClassificationsDropDownComponent
                          data={newFeeClassificationList}
                          onSelect={(value, label) => {
                            setFieldValue(fields.feeClassification, value);
                            setFieldValue(fields.feeClassificationName, label);
                          }}
                          setData={(newData) =>
                            setNewFeeClassificationList(newData)
                          }
                          value={values[fields.feeClassificationName]}
                        />
                      }
                      disabled={isEdit && !isSave}
                      component={FieldDropSide}
                    />
                  </div>
                  {!isUndefined(feeId) &&
                    feeId != 0 &&
                    getBasicFeeDetails?.step == 5 && (
                      <div
                        className={"d-flex mr-3"}
                        style={{ cursor: isEdit ? "not-allowed" : "default" }}
                      >
                        <Form.Check
                          type="switch"
                          autoFocus="off"
                          id={"feeStatus"}
                          name={fields.feeStatus}
                          checked={values[fields.feeStatus]}
                          onChange={() => {
                            setFieldValue(
                              fields.feeStatus,
                              !values[fields.feeStatus]
                            );
                            setFeeStatus(!feeStatus);
                          }}
                          disabled={isEdit && !isSave}
                          className="medium"
                        />{" "}
                        <span className="ml-3">
                          {feeStatus == true ? "Active" : "Inactive"}
                        </span>
                      </div>
                    )}
                </ManageFeeLayout>
              </Form>
            );
          }}
        </Formik>
      </div>
    </LoaderWrapper>
  );
};
export default CreateFeeContainer;
